<template>
  <div class="position-relative h-100 w-100">
    <div class="map-header position-absolute text-light">
      <h2 class="h3 m-0"><span>Day 01 - </span>Points</h2>
    </div>
    <dl class="map-source position-absolute d-flex">
      <dt class="me-1">Source:</dt>
      <dd class="text-break">
        <a href="https://earthquake.usgs.gov" target="_blank"
          >https://earthquake.usgs.gov</a
        >
      </dd>
    </dl>
    <div ref="map-root" class="basemap"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import AnimatedPopup from "mapbox-gl-animated-popup";
import "mapbox-gl/src/css/mapbox-gl.css";
import moment from "moment";
// import earthquakes from "../assets/earthquakes.geojson";

export default {
  data() {
    return {
      accessToken:
        "pk.eyJ1Ijoia21hcnNoYWxsIiwiYSI6ImNrdXdudGlpODI2ejkydXF2bXcyM3poaWQifQ.hyBCr6uwWlDGMGyVmuKCIw",
      map: null,
    };
  },
  methods: {
    initMap() {
      mapboxgl.accessToken = this.accessToken;

      const bounds = [
        [-191.95312499999778, -83.53996971923],
        [191.95312499999864, 83.5399697192303],
      ];

      this.map = new mapboxgl.Map({
        container: this.$refs["map-root"],
        style: "mapbox://styles/mapbox/dark-v10",
        center: [39.8596584, -12.7036393],
        maxBounds: bounds,
      });

      this.map.on("load", () => {
        // Add a geojson point source.
        // Heatmap layers also work with a vector tile source.
        this.map.addSource("earthquakes", {
          type: "geojson",
          data: "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_month.geojson",
        });
        this.map.addLayer({
          id: "earthquakes",
          type: "circle",
          source: "earthquakes",
          paint: {
            "circle-color": "#ff0000",
            "circle-blur": 1,
            "circle-radius": {
              property: "mag",
              base: 1.8,
              stops: [
                [{ zoom: 0, value: 2 }, 1],
                [{ zoom: 0, value: 8 }, 40],
                [{ zoom: 11, value: 2 }, 10],
                [{ zoom: 11, value: 8 }, 2400],
                [{ zoom: 20, value: 2 }, 20],
                [{ zoom: 20, value: 8 }, 6000],
              ],
            },
          },
        });

        // disable map rotation using right click + drag
        this.map.dragRotate.disable();

        // disable map rotation using touch rotation gesture
        this.map.touchZoomRotate.disableRotation();

        // When a click event occurs on a feature in the places layer, open a popup at the
        // location of the feature, with description HTML from its properties.
        this.map.on("click", "earthquakes", (e) => {
          // Copy coordinates array.
          const coordinates = e.features[0].geometry.coordinates.slice();
          const mag = e.features[0].properties.mag;
          const place = e.features[0].properties.place;

          const time = moment(e.features[0].properties.time).format(
            "DD/MM/YYYY hh:mm a"
          );
          const html = `
          <table class="table">
            <tr>
              <td>Magnitude:</td>
              <td>${mag}</td>
            </tr>
            <tr>
              <td>Location:</td>
              <td>${place}</td>
            </tr>
            <tr>
              <td>Time:</td>
              <td>${time}</td>
            </tr>
          </table>
          `;

          // Ensure that if the map is zoomed out such that multiple
          // copies of the feature are visible, the popup appears
          // over the copy being pointed to.
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }

          this.popup = new AnimatedPopup({
            offset: 5,
            openingAnimation: {
              duration: 500,
              easing: "easeOutElastic",
            },
            closingAnimation: {
              duration: 200,
              easing: "easeOutElastic",
            },
            closeButton: false,
          })
            .setLngLat(coordinates)
            .setHTML(html)
            .addTo(this.map);
        });

        // Change the cursor to a pointer when the mouse is over the places layer.
        this.map.on("mouseenter", "earthquakes", () => {
          this.map.getCanvas().style.cursor = "pointer";
        });

        // Change it back to a pointer when it leaves.
        this.map.on("mouseleave", "earthquakes", () => {
          this.map.getCanvas().style.cursor = "";
        });
      });

      const nav = new mapboxgl.NavigationControl();
      this.map.addControl(nav, "top-right");
      this.map.scrollZoom.disable();
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/map-shared.scss";

:deep(.mapboxgl-popup-content) {
  color: #191919;
  z-index: 3;
  font-size: 1rem;
  font-family: inherit;
}
</style>
